<template>
  <div class="right">
    <div style="text-align:center;font-weight:900;font-size:0.16rem;margin:0.4rem 0.2rem 0.2rem 0.2rem">
      ISO 27XXX / ISMS / 信息安全管理体系系列标准介绍
    </div>
    <div style="text-align:right">
      <p>编辑整理：吴超、LISA、1DING</p>
      <p>整理日期：2019年5月</p>
    </div>
    <p style="margin-top:0.2rem">ISO27XXX系列标准从BS
      7799-1:1995开始，经过近25年的发展，截止2019年4月30日，已经正式发布的标准共有52项。其中10项已被吸纳为国家标准，同时还有数十项标准仍在制定中。</p>
    <p>
      已发布的52项标准除了覆盖常规的术语概念、基本要求、风险管理、实施指南之外，还对数据处理（包括数据编辑、数据交互、个人隐私）、云服务安全、存储安全、应用安全、网络安全、供方安全、安全事件、调查取证（包括电子证据和电子取证）、应急管理等领域制定了相应的标准。
    </p>
    <div style="max-width:8rem;margin:0 auto;padding:0">
      <svg width="1200" height="1200" viewBox="0,0,1200,1200" preserveAspectRatio="xMinYMin meet" class="svg"></svg>
    </div>
    <div style:="display: table-cell;vertical-align: middle">
      <p style="font-weight:700">已经被吸纳为GB的10项标准如下</p>
      <ul>
        <li>
          <p> GB/T 29246-2017/ISO/IEC 27000:2016 信息技术 安全技术 信息安全管理体系概述和词汇</p>
        </li>
        <li>
          <p> GB/T 22080-2016/ISO/IEC 27001:2013 信息技术 安全技术 信息安全管理体系 要求</p>
        </li>
        <li>
          <p> GB/T 22081-2016/ISO/IEC 27002:2013 信息技术 安全技术 信息安全控制实用规则</p>
        </li>
        <li>
          <p> GB/T 31496-2015/ISO/IEC 27003:2010 信息技术 安全技术 信息安全管理体系实施指南</p>
        </li>
        <li>
          <p> GB/T 31722-2015/ISO/IEC 27005:2008 信息技术 安全技术 信息安全风险管理</p>
        </li>
        <li>
          <p> GB/T 25067-2016/ISO/IEC 27006:2011 信息技术 安全技术 信息安全管理体系审核和认证机构要求</p>
        </li>
        <li>
          <p> GB/Z 32916-2016/ISO/IEC TR 27008:2011 信息技术 安全技术 信息安全控制措施审核员指南</p>
        </li>
        <li>
          <p> GB/T 32920-2016/ISO/IEC 27010:2012 信息技术 安全技术 行业间和组织间通信的信息安全管理</p>
        </li>
        <li>
          <p> GB/T 32923-2016/ISO/IEC 27014:2013 信息技术 安全技术 信息安全治理</p>
        </li>
        <li>
          <p> GB/T 20985.1-2017/ISO/IEC 27035-1:2016 信息技术 安全技术 信息安全事件管理 第1部分：事件管理原理</p>
        </li>
      </ul>
    </div>
    <p style="font-weight:700;margin-top:0.1rem"> 已发布的52项标准主要涵盖：</p>
    <ul>
      <li>
        <p>术语概念 （1项）</p>
        <ul>
          <li>
            ISO/IEC 27000:2018 信息技术 安全技术 信息安全管理体系 概述和术语
          </li>
        </ul>
      </li>
      <li>
        <p>基本要求 （1项）</p>
        <ul>
          <li>
            ISO/IEC 27001:2013 信息技术 安全技术 信息安全管理体系 要求
          </li>
        </ul>
      </li>
      <li>
        <p>行业指南 （5项）</p>
        <ul>
          <li>
            ISO/IEC 27009:2016 信息技术 安全技术 ISO/IEC 27001在特定行业的应用 - 要求
          </li>
          <li>
            ISO/IEC 27011:2016 信息技术 安全技术 通讯组织基于ISO/IEC信息安全控制措施的实施指南
          </li>
          <li>
            ISO/IEC 27015:2012 信息技术 安全技术 金融服务的信息安全管理指南
          </li>
          <li>
            ISO/IEC 27019:2017 信息技术 安全技术 能源行业的信息安全控制措施
          </li>
          <li>
            ISO/IEC 27799:2016 健康信息 - ISO/IEC 27002在健康医疗行业的应用
          </li>
        </ul>
      </li>
      <li>
        <p>安全治理 （1项）</p>
        <ul>
          <li>
            ISO/IEC 27014:2013 信息技术 安全技术 信息安全治理
          </li>
        </ul>
      </li>
      <li>
        <p>人员能力 （1项）</p>
        <ul>
          <li>
            ISO/IEC 27021:2017 信息技术 安全技术 信息安全管理专业人员的能力要求
          </li>
        </ul>
      </li>
      <li>
        <p>体系实施 （7项）</p>
        <ul>
          <li>
            <p>通用指南</p>
          </li>
          <ul>
            <li>
              ISO/IEC 27002:2013 信息技术 安全技术 信息安全控制措施实用规则
            <li>
              ISO/IEC 27003:2017 信息技术 安全技术 信息安全管理体系 指南
            </li>
            <li>
              ISO/IEC 27023:2015 信息技术 安全技术 ISO/IEC 27001和ISO/IEC 27002 版本变化对照
            </li>
          </ul>
          <li>
            <p>体系整合</p>
          </li>
          <ul>
            <li>
              ISO/IEC 27013:2015 信息技术 安全技术 ISO/IEC 27001和ISO/IEC 20000-1 整合实施指南
            </li>
          </ul>
          <li>
            <p>风险管理</p>
          </li>
          <ul>
            <li>
              ISO/IEC 27005:2018 信息技术 安全技术 信息安全风险管理
            </li>
          </ul>
          <li>
            <p>测量分析</p>
          </li>
          <ul>
            <li>
              ISO/IEC 27004:2016 信息技术 安全技术 安全管理管理 - 监视、测量、分析和评估
            </li>
          </ul>
          <li>
            <p>经济性</p>
          </li>
          <ul>
            <li>
              ISO/IEC 27016:2014 信息技术 安全技术 信息安全管理 组织经济性
            </li>
          </ul>
        </ul>
      </li>
      <li>
        <p>体系审核 （3项）</p>
        <ul>
          <li>
            ISO/IEC 27006:2015 信息技术 安全技术 信息安全管理体系审核和认证机构要求
          </li>
          <li>
            ISO/IEC 27007:2017 信息技术 安全技术 信息安全管理体系审核指南
          </li>
          <li>
            ISO/IEC 27008:2011 信息技术 安全技术 信息安全控制措施审核员指南
          </li>
        </ul>
      </li>
      <li>
        <p>数据安全</p>
        <ul>
          <li>
            <p>数据交互 （1项）</p>
            <ul>
              <li>
                ISO/IEC 27010:2015 信息技术 安全技术 跨行业、跨组织通讯的信息安全管理
              </li>
            </ul>
          </li>
          <li>
            <p>数据处理 （1项）</p>
            <ul>
              <li>
                ISO/IEC 27038:2014 信息技术 安全技术 数据编辑规范
              </li>
            </ul>
          </li>
          <li>
            <p>个人隐私 （1项）</p>
            <ul>
              <li>
                ISO/IEC 27018:2019 信息技术 安全技术 个人隐私信息处理方在公有云中对个人隐私信息保护实施指南
              </li>
            </ul>
          </li>
        </ul>
      </li>
      <li>
        <p>存储安全 （1项）</p>
        <ul>
          <li>
            ISO/IEC 27040:2015 信息技术 安全技术 存储安全
          </li>
        </ul>
      </li>
      <li>
        <p>云安全 （1项）</p>
        <ul>
          <li>
            ISO/IEC 27017:2015 信息技术 安全技术 云服务基于ISO/IEC 27002信息安全控制措施的实施指南
          </li>
        </ul>
      </li>
      <li>
        <p>网络安全 （6项）</p>
        <ul>
          <li>
            ISO/IEC 27033-1:2015 信息技术 安全技术 网络安全 第一部分：概述和概念
          </li>
          <li>
            ISO/IEC 27033-2:2012 信息技术 安全技术 网络安全 第二部分：设计和实施网络安全
          </li>
          <li>
            ISO/IEC 27033-3:2010 信息技术 安全技术 网络安全 第三部分：网络场景参考 - 威胁、设计方法和控制事项
          </li>
          <li>
            ISO/IEC 27033-4:2014 信息技术 安全技术 网络安全 第四部分：利用安全网关保障网络间通讯安全
          </li>
          <li>
            ISO/IEC 27033-5:2013 信息技术 安全技术 网络安全 第五部分：利用VPN保障网络间通讯安全
          </li>
          <li>
            ISO/IEC 27039:2015 信息技术 安全技术 选择、部署和运行入侵检测系统
          </li>
        </ul>
      </li>
      <li>
        <p>应用安全 （8项）</p>
        <ul>
          <li>
            ISO/IEC 27034-1:2011 信息技术 安全技术 应用安全 第一部分：概述和概念
          </li>
          <li>
            ISO/IEC 27034-2:2015 信息技术 安全技术 应用安全 第二部分：组织规范框架
          </li>
          <li>
            ISO/IEC 27034-3:2018 信息技术 安全技术 应用安全 第三部分：应用安全管理过程
          </li>
          <li>
            ISO/IEC 27034-5:2017 信息技术 安全技术 应用安全 第五部分：协议和应用安全控制数据结构
          </li>
          <li>
            ISO/IEC 27034-5-1:2018 信息技术 安全技术 应用安全 第五部分：协议和应用安全控制数据结构，1. XML规则
          </li>
          <li>
            ISO/IEC 27034-6:2016 信息技术 安全技术 应用安全 第六部分：范例分析
          </li>
          <li>
            ISO/IEC 27034-7:2018 信息技术 安全技术 应用安全 第七部分：保障预测框架
          </li>
        </ul>
      </li>
      <li>
        <p>安全事件 （2项）</p>
        <ul>
          <li>
            ISO/IEC 27035-1:2016 信息技术 安全技术 信息安全事件管理 第一部分： 事件管理原则
          </li>
          <li>
            ISO/IEC 27035-2:2016 信息技术 安全技术 信息安全事件管理 第二部分： 事件响应计划和准备指南
          </li>
        </ul>
      </li>
      <li>
        <p>应急管理 （1项）</p>
        <ul>
          <li>
            ISO/IEC 27031:2011 信息技术 安全技术 信息和通讯技术业务连续性准备指南
          </li>
        </ul>
      </li>
      <li>
        <p>网络空间安全 （2项）</p>
        <ul>
          <li>
            ISO/IEC 27032:2012 信息技术 安全技术 网络空间安全指南
          </li>
          <li>
            ISO/IEC 27103:2018 信息技术 安全技术 网络空间安全与ISO及IEC标准
          </li>
        </ul>
      </li>
      <li>
        <p>供方安全 （4项）</p>
        <ul>
          <li>
            ISO/IEC 27036-1:2014 信息技术 安全技术 供方关系的信息安全 第一部分：概述和概念
          </li>
          <li>
            ISO/IEC 27036-2:2014 信息技术 安全技术 供方关系的信息安全 第二部分：要求
          </li>
          <li>
            ISO/IEC 27036-3:2013 信息技术 安全技术 供方关系的信息安全 第三部分：信息和通讯技术供应链安全指南
          </li>
          <li>
            ISO/IEC 27036-4:2016 信息技术 安全技术 供方关系的信息安全 第四部分：云服务安全指南
          </li>
        </ul>
      </li>
      <li>
        <p>调查取证 （7项）</p>
        <ul>
          <li>
            <p> 事件调查</p>
          </li>
          <ul>
            <li>
              ISO/IEC 27041:2015 信息技术 安全技术 确保事件调查方法适用性和充分性的指南
            </li>
            <li>
              ISO/IEC 27043:2015 信息技术 安全技术 事件调查原则和流程
            </li>
          </ul>
          <li>
            <p> 数字证据</p>
          </li>
          <ul>
            <li>
              ISO/IEC 27037:2012 数字证据识别、收集、获取与保护指南
            </li>
            <li>
              ISO/IEC 27042:2015 信息技术 安全技术 数字证据分析和解释指南
            </li>
          </ul>
          <li>
            <p> 电子取证</p>
          </li>
          <ul>
            <li>
              ISO/IEC 27050-1:2016 信息技术 安全技术 电子取证.第一部分：概述和概念
            </li>
            <li>
              ISO/IEC 27050-1:2016 信息技术 安全技术 电子取证.第二部分：电子取证治理和管理指南
            </li>
            <li>
              ISO/IEC 27050-3:2017 信息技术 安全技术 电子取证 第三部分：电子取证实用规则
            </li>
          </ul>
        </ul>
      </li>
    </ul>
    <p style="margin-bottom:0.2rem">&nbsp;</p>
  </div>
</template>

<script>
  import * as d3 from "d3";
  import axios from "axios";
  import global_ from "@/misc/global.vue";
  export default {
    data() {
      return {
        description: {
          standards_code: "",
          standards_name: "",
          related_standards_code: "",
          serials: ""
        },
        serials: {
          code: "C0",
          name: "ISO27000系列",
          children: [{
              code: "C01",
              name: "术语概念",
              children: [{
                code: "27000",
                open: "ISO/IEC 27000:2018",
                name: "概述与词汇",
                newest: "2018",
                version: "2009,2012,2013,2016,2018"
              }]
            },
            {
              code: "C02",
              name: "基本要求",
              children: [{
                code: "27001",
                open: "ISO/IEC 27001:2013",
                name: "要求",
                newest: "2013",
                version: "2005,2013"
              }]
            },
            {
              code: "C03",
              name: "行业指南",
              children: [{
                  code: "27009",
                  open: "ISO/IEC 27009:2016",
                  name: "在特定行业应用的要求",
                  newest: "2016",
                  version: "2016"
                }, {
                  code: "27011",
                  open: "ISO/IEC 27011:2016",
                  name: "电信行业",
                  newest: "2016",
                  version: "2016"
                },
                {
                  code: "27015",
                  open: "ISO/IEC 27015:2012",
                  name: "金融服务",
                  newest: "2015(废止)",
                  version: "2015"
                },
                {
                  code: "27019",
                  open: "ISO/IEC 27019:2017",
                  name: "能源行业",
                  newest: "2017",
                  version: "2013,2017"
                },
                {
                  code: "27799",
                  open: " ",
                  name: "医疗健康",
                  newest: "2016",
                  version: "2008,2016"
                }
              ]
            },
            {
              code: "C04",
              name: "安全治理",
              children: [{
                code: "27014",
                open: "ISO/IEC 27014:2013",
                name: "信息安全治理",
                newest: "2013",
                version: "2013"
              }]
            },
            {
              code: "C05",
              name: "人员能力",
              children: [{
                code: "27021",
                open: "ISO/IEC 27021:2017",
                name: "安全人员能力要求",
                newest: "2017",
                version: "2017"
              }]
            },
            {
              code: "C06",
              name: "体系实施",
              children: [{
                  code: "C06-01",
                  name: "通用指南",
                  children: [{
                      code: "27002",
                      open: "ISO/IEC 27002:2013",
                      name: "实用规则",
                      newest: "2013",
                      version: "2005,2013"
                    }, {
                      code: "27003",
                      open: "ISO/IEC 27003:2017",
                      name: "实施指南",
                      newest: "2017",
                      version: "2010,2017"
                    },
                    {
                      code: "27023",
                      open: "ISO/IEC 27023:2015",
                      name: "版本对照",
                      newest: "2015",
                      version: "2015"
                    }
                  ]
                },
                {
                  code: "C06-02",
                  name: "体系整合",
                  children: [{
                    code: "27013",
                    open: "ISO/IEC 27013:2015",
                    name: "与ISO20000的整合",
                    newest: "2012",
                    version: "2012"
                  }]
                },
                {
                  code: "C06-03",
                  name: "风险管理",
                  children: [{
                    code: "27005",
                    open: "ISO/IEC 27005:2018",
                    name: "风险管理",
                    newest: "2018",
                    version: "2008,2011,2018"
                  }]
                },
                {
                  code: "C06-04",
                  name: "测量分析",
                  children: [{
                    code: "27004",
                    open: "ISO/IEC 27004:2016",
                    name: "测量分析",
                    newest: "2016",
                    version: "2011,2016"
                  }]
                }, {
                  code: "C06-05",
                  name: "经济性",
                  children: [{
                    code: "27016",
                    open: "ISO/IEC 27016:2014",
                    name: "信息安全的经济性",
                    newest: "2014",
                    version: "2014"
                  }]
                }
              ]
            },
            {
              code: "C07",
              name: "体系审核",
              children: [{
                  code: "27006",
                  open: "ISO/IEC 27006:2015",
                  name: "对认证机构的要求",
                  newest: "2015",
                  version: "2007,2011,2015"
                }, {
                  code: "27007",
                  open: "ISO/IEC 27007:2017",
                  name: "管理体系审核指南",
                  newest: "2017",
                  version: "2011,2017"
                },
                {
                  code: "27008",
                  open: "ISO/IEC 27008:2011",
                  name: "控制措施审核指南",
                  newest: "2011",
                  version: "2011"
                },
              ]
            },
            {
              code: "C08",
              name: "数据安全",
              children: [{
                  code: "C08-01",
                  name: "数据交互",
                  children: [{
                    code: "27010",
                    open: "ISO/IEC 27010:2015",
                    name: "跨行业、跨组织间通讯安全",
                    newest: "2015",
                    version: "2015,2012"
                  }]
                },
                {
                  code: "C08-02",
                  name: "数据处理",
                  children: [{
                    code: "27038",
                    open: "ISO/IEC 27038:2014",
                    name: "数据修编",
                    newest: "2014",
                    version: "2014"
                  }]
                },
                {
                  code: "C08-03",
                  name: "个人隐私",
                  children: [{
                    code: "27018",
                    open: "ISO/IEC 27018:2014",
                    name: "个人隐私",
                    newest: "2014",
                    version: "2014,2019"
                  }]
                }
              ]
            },
            {
              code: "C09",
              name: "应用安全",
              children: [{
                  code: "27034-1",
                  open: "ISO/IEC 27034-1:2011",
                  name: "概念和综述",
                  newest: "2011",
                  version: "2011"
                },
                {
                  code: "27034-2",
                  open: "ISO/IEC 27034-2:2015",
                  name: "组织规范性框架",
                  newest: "2015",
                  version: "2015"
                },
                {
                  code: "27034-3",
                  open: "ISO/IEC 27034-3:2018",
                  name: "应用安全管理过程",
                  newest: "2018",
                  version: "2018"
                },
                {
                  code: "27034-5",
                  open: "ISO/IEC 27034-5:2017",
                  name: "协议与数据结构",
                  newest: "2017",
                  version: "2017"
                },
                {
                  code: "27034-5-1",
                  open: "ISO/IEC 27034-5-1:2018",
                  name: "协议与数据结构 - XML",
                  newest: "2018",
                  version: "2018"
                },
                {
                  code: "27034-6",
                  open: "ISO/IEC 27034-6:2016",
                  name: "案例分析",
                  newest: "2016",
                  version: "2016"
                },
                {
                  code: "27034-7",
                  open: "ISO/IEC 27034-7:2018",
                  name: "保障预测框架",
                  newest: "2018",
                  version: "2018"
                }
              ]
            },
            {
              code: "C10",
              name: "存储安全",
              children: [{
                code: "27040",
                open: "ISO/IEC 27040:2015",
                name: "存储安全",
                newest: "2015",
                version: "2015"
              }]
            },
            {
              code: "C11",
              name: "云安全",
              children: [{
                code: "27017",
                open: "ISO/IEC 27017:2015",
                name: "云服务安全",
                newest: "2015",
                version: "2015"
              }]
            },
            {
              code: "C12",
              name: "网络安全",
              children: [{
                  code: "27033-1",
                  open: "ISO/IEC 27033-1:2015",
                  name: "网络安全 - 框架与概念",
                  newest: "2015",
                  version: "2015"
                },
                {
                  code: "27033-2",
                  open: "ISO/IEC 27033-2:2012",
                  name: "网络安全 - 设计与实现",
                  newest: "2014",
                  version: "2014"
                },
                {
                  code: "27033-3",
                  open: "ISO/IEC 27033-3:2010",
                  name: "网络安全 - 参考网络场景",
                  newest: "2010",
                  version: "2010"
                },
                {
                  code: "27033-4",
                  open: "ISO/IEC 27033-4:2014",
                  name: "网络安全 - 安全网关",
                  newest: "2014",
                  version: "2014"
                },
                {
                  code: "27033-5",
                  open: "ISO/IEC 27033-5:2013",
                  name: "网络安全 - VPN",
                  newest: "2013",
                  version: "2013"
                },
                {
                  code: "27033-6",
                  open: " ",
                  name: "网络安全 - 无线网",
                  newest: "2016",
                  version: "2016"
                },
                {
                  code: "27039",
                  open: "ISO/IEC 27039:2015",
                  name: "入侵检测系统",
                  newest: "2015",
                  version: "2015"
                }
              ]
            },
            {
              code: "C13",
              name: "供方安全",
              children: [{
                  code: "27036-1",
                  open: "ISO/IEC 27036-1:2014",
                  name: "概念和综述",
                  newest: "2014",
                  version: "2014"
                },
                {
                  code: "27036-2",
                  open: "ISO/IEC 27036-2:2014",
                  name: "要求",
                  newest: "2014",
                  version: "2014"
                },
                {
                  code: "27036-3",
                  open: "ISO/IEC 27036-3:2013",
                  name: "ICT供应链安全",
                  newest: "2013",
                  version: "2013"
                },
                {
                  code: "27036-4",
                  open: "ISO/IEC 27036-4:2016",
                  name: "云服务安全",
                  newest: "2016",
                  version: "2016"
                }
              ]
            },
            {
              code: "C14",
              name: "事件管理",
              children: [{
                  code: "27035-1",
                  open: "ISO/IEC 27035-1:2016",
                  name: "原则",
                  newest: "2016",
                  version: "2016"
                },
                {
                  code: "27035-2",
                  open: "ISO/IEC 27035-2:2016",
                  name: "计划和准备",
                  newest: "2016",
                  version: "2016"
                }
              ]
            },
            {
              code: "C15",
              name: "应急管理",
              children: [{
                code: "27031",
                open: "ISO/IEC 27031:2011",
                name: "ICT连续性",
                newest: "2011",
                version: "2011"
              }]
            },
            {
              code: "C16",
              name: "调查取证",
              children: [{
                  code: "C16-01",
                  name: "事件调查",
                  children: [{
                      code: "27041",
                      open: "ISO/IEC 27041:2015",
                      name: "事件调查方法",
                      newest: "2015",
                      version: "2015"
                    },
                    {
                      code: "27043",
                      open: "ISO/IEC 27043:2015",
                      name: "事件调查原则",
                      newest: "2015",
                      version: "2015"
                    }
                  ]
                },
                {
                  code: "C16-02",
                  name: "电子证据",
                  children: [{
                      code: "27037",
                      open: "ISO/IEC 27037:2012",
                      name: "识别收集存管",
                      newest: "2012",
                      version: "2012"
                    },
                    {
                      code: "27042",
                      open: "ISO/IEC 27042:2015",
                      name: "分析和解读",
                      newest: "2015",
                      version: "2015"
                    }
                  ]
                },
                {
                  code: "C16-03",
                  name: "电子取证",
                  children: [{
                      code: "27050-1",
                      open: "ISO/IEC 27050-1:2016",
                      name: "概念和综述",
                      newest: "2016",
                      version: "2016"
                    },
                    {
                      code: "27050-2",
                      open: " ",
                      name: "治理和管理指南",
                      newest: "2018",
                      version: "2018"
                    },
                    {
                      code: "27050-3",
                      open: "ISO/IEC 27050-3:2017",
                      name: "实用规则",
                      newest: "2017",
                      version: "2017"
                    }
                  ]
                },
              ]
            },
            {
              code: "C17",
              name: "网络空间",
              children: [{
                  code: "27032",
                  open: "ISO/IEC 27032:2012",
                  name: "网络空间安全",
                  newest: "2012",
                  version: "2012"
                },
                {
                  code: "27103",
                  open: "ISO/IEC 27103:2018",
                  name: "与ISO标准关系",
                  newest: "2018",
                  version: "2018"
                }
              ]
            }
          ]
        }
      };
    },
    mounted() {
      var _this = this;
      var svg = d3.select("svg"),
        width = +svg.attr("width") / 2,
        height = +svg.attr("height") / 2,
        g = svg
        .append("g")
        .attr("transform", "translate(" + width + "," + height + ")");
      var hierarchy = d3.hierarchy(this.serials);

      var tree = d3
        .cluster()
        .size([360, 360])
        .separation(function (a, b) {
          return (a.parent == b.parent ? 1 : 2) / a.depth;
        });

      var root = tree(hierarchy);

      g.selectAll(".link")
        .data(root.descendants().slice(1))
        .enter()
        .append("path")
        .attr("class", "link")
        .attr("d", function (d) {
          return (
            "M" +
            project(d.x, d.y) +
            "C" +
            project(d.x, (d.y + d.parent.y) / 2) +
            " " +
            project(d.parent.x, (d.y + d.parent.y) / 2) +
            " " +
            project(d.parent.x, d.parent.y)
          );
        });

      var node = g
        .selectAll(".node")
        .data(root.descendants())
        .enter()
        .append("g")
        .attr("class", "node")
        .attr("transform", function (d) {
          return "translate(" + project(d.x, d.y) + ")";
        })
        .attr("id", function (d) {
          return "g" + d.data.code;
        })
        .on("mouseover", function (d) {
          d.eachAfter(function (e) {
            d3.select("#g" + e.data.code).attr("class", "nodeHover");
          });
        })
        .on("mouseout", function (d) {
          d.eachAfter(function (e) {
            d3.select("#g" + e.data.code).attr("class", "node");
          });
        })
        .on("click", function (d) {
          if (d.data.open && d.data.open != " ") {
            _this.openStardards(d.data.open)
          }
        })

      node.append("circle").attr("r", 2.5);

      node
        .append("text")
        .attr("style", function (d) {
          if (d.depth == 0) {
            return "font-size:14px;stroke:#aa0000;stroke-width:1px;fill:#aa0000"
          } else {
            return "font-size:12px"
          }
        })
        .attr("dy", ".31em")
        .attr("x", function (d) {
          return d.x < 180 === !d.children ? 6 : -6;
        })
        .style("text-anchor", function (d) {
          return d.x < 180 === !d.children ? "start" : "end";
        })
        .attr("transform", function (d) {
          return "rotate(" + (d.x < 180 ? d.x - 90 : d.x + 90) + ")";
        })
        .text(function (d) {
          if (new RegExp("^C.*$").test(d.data.code)) {
            return d.data.name;
          } else {
            return d.data.code + "： " + d.data.name;
          }
        })

      function project(x, y) {
        var angle = ((x - 90) / 180) * Math.PI,
          radius = y;
        return [radius * Math.cos(angle), radius * Math.sin(angle)];
      }
    },
    methods: {
      openStardards(para) {
        var newWindow = window.open()
        // 首先获取标准描述
        axios.get(global_.BAK_URL + "getStandardsDescription/", {
            params: {
              keywords: para
            },
            async: false
          })
          .then(response => {
            // 再根据标准描述，打开标准条款
            const {
              href
            } = this.$router.resolve({
              path: "/showStandards",
              query: {
                standards_code: response.data[0].standards_code,
                standards_name: response.data[0].standards_name,
                related_standards_code: response.data[0].related_standards_code,
                serials: response.data[0].serials
              }
            });
            newWindow.location.href = href;
          })
      }
    }
  };
</script>

<style scoped>
  .right {
    width: 100%;
  }

  .right .svg {
    display: block;
    padding: 0;
    height: 100%;
    width: 100%;
  }

  .right ul {
    margin: 0 0.1rem;
    padding: 0 0.1rem;
  }
</style>

<style>
  .node circle {
    fill: #6f6f6f;
  }

  .node text {
    font: 14px sans-serif;
    fill: #2f2f2f;
  }

  .nodeHover circle {
    fill: #ff9999;
  }

  .nodeHover text {
    font: 15px sans-serif;
    font-weight: 900;
    fill: #aa0000;
    cursor: pointer;
  }

  .link {
    fill: none;
    stroke: #2f2f2f;
    stroke-opacity: 0.5;
    stroke-width: 0.7px;
  }
</style>